import { getImageFromS3 } from '../../../imageService';

export const challengeComponent = [
  {
    id: 'challenges-as-opportunities',
    title: 'Виклики як можливість',
    description: 'Інколи саме у викликах з’являються нові можливості.\n\n' +
      'Ми зібрали приклади країн, які змогли використали скрутні часи як старт для змін.\n',
    backgroundImage: getImageFromS3(
      '/images/challenges-as-opportunities/bg.png'
    ),
    subDescription: '',
    startButtonTitle: 'Поїхали!',
    histories: [
      {
        id: 1,
        title: 'Від руїн до економічного лідера всього за 30 років.',
        image: getImageFromS3('/images/challenges-as-opportunities/1.png'),
        historyTitle: 'Японія після Другої світової війни зробила ставку на знання та якість.',
        historySteps: [
          'Фокус на ефективності промисловості.',
          'Інвестиції в освіту та інженерію.',
          'Постійне вдосконалення та товари з високою доданою вартістю.'
        ],
        historyResult: 'японські бренди — світовий еталон, економіка — одна з найсильніших.'
      },
      {
        id: 2,
        title: 'Від бідності до технологічного прориву',
        image: getImageFromS3('/images/challenges-as-opportunities/2.png'),
        historyTitle: 'Сінгапур після здобуття незалежності (1965) зробив ставку на ефективність та інновації.',
        historySteps: [
          'Залучення іноземних інвестицій та міжнародного бізнесу.',
          'Фокус на освіту, науку і високі технології.',
          'Розвиток порту та транспортної інфраструктури.'
        ],
        historyResult: 'сьогодні Сінгапур — один із найзаможніших технологічних і фінансових центрів Азії з високим рівнем життя.'
      },
      {
        id: 3,
        title: 'Від військових руїн до стартап-економіки.',
        image: getImageFromS3('/images/challenges-as-opportunities/3.png'),
        historyTitle: 'Ізраїль після заснування (1948) зробив ставку на освіту та інновації.',
        historySteps: [
          'Масштабні інвестиції в освіту та науку.',
          'Використання обмежених ресурсів через технології (наприклад, опріснення води, агротехніка)',
          'Створення культури підприємництва і стартапів.'
        ],
        historyResult: 'сьогодні країна відома як «стартап-нація», її технології використовуються у всьому світі, а економіка стабільно розвивається.'
      },
      {
        id: 4,
        title: 'Від бідності до зеленої енергетики.',
        image: getImageFromS3('/images/challenges-as-opportunities/4.png'),
        historyTitle: 'Данія після нафтової кризи 1970-х зробила ставку на енергонезалежність та екологію.',
        historySteps: [
          'Масштабні інвестиції в альтернативну енергетику (вітер).',
          'Підтримка стартапів та інновацій у «зелених» технологіях.',
          'Формування національної стратегії сталого розвитку.'
        ],
        historyResult: 'Данія стала світовим лідером у вітровій енергетиці, експортує технології на мільярди та мінімізувала залежність від імпорту.'
      },
      {
        id: 5,
        title: 'Від ізольованості до фінансового хабу',
        image: getImageFromS3('/images/challenges-as-opportunities/5.png'),
        historyTitle: 'Швейцарія після Наполеонівських війн зробила ставку на стабільність та якість.',
        historySteps: [
          'Політична стабільність і дотримання нейтралітету.',
          'Розвиток банківської системи та фінансових послуг.',
          'Залучення міжнародного бізнесу та інновацій.'
        ],
        historyResult: 'сьогодні Швейцарія — один із найстабільніших фінансових центрів світу з найвищим рівнем життя.'
      }
    ],
    resultTitle: 'Історії цих країн доводять: криза — це не кінець, а точка вибору.\n' +
      'Навіть без ідеальних умов для старту можна знайти шлях, якщо поставити ставку на людей, знання і системні зусилля.',
    resultSubTitle: 'Сподіваємось, що ці історії надихнули тебе. Залишайся з нами — попереду ще багато цікаво.'
  }
];
